import { render, h } from "preact";
import { ArticleListContainer, type ArticleListContainerProps } from "./article-list-container";
import { magazineTabClickHandler } from "./magazine-tabs";
import { getActiveTab, getTagList, parseIntEx } from "./magazine-helpers";

const bootstrapMagazineTabs = (): void => {
  const listcontainerElement = document.getElementById("related-articles");
  if (!listcontainerElement) return;
  magazineTabClickHandler(getTagList(listcontainerElement), listcontainerElement.dataset.basePath as string);
};

const bootstrapMagazineOverview = (): void => {
  const listcontainerElement = document.getElementById("related-articles");
  if (!listcontainerElement) return;

  const urlParamTag = listcontainerElement.dataset.tag;
  const tag = getActiveTab(getTagList(listcontainerElement));
  const props: ArticleListContainerProps = {
    id: listcontainerElement.dataset.pageid as string,
    tag: urlParamTag || tag,
    take: parseIntEx(listcontainerElement.dataset.maxarticles as string, 3),
    useMagazineTemplate: listcontainerElement.dataset.usemagazinetemplate === "true",
    relatedTitle: listcontainerElement.dataset.relatedTitle as string,
  };
  render(h(ArticleListContainer, props), listcontainerElement);
};

bootstrapMagazineTabs();
bootstrapMagazineOverview();
